import * as actions from "./actions";
import {
   initStoreData,
   getFilterStoreData,
   getStoreById,
   getStoreCollections,
   updateStoreData,
   deleteProduct,
   getModels,
   getCollectionBuId,
   updateCategory,
   createCategory,
   deleteCategory,
   createStore,
   initCategories,
   getValidationNumbers,
   // getOrderRequestForms,
   getOrderRequests,
   getOrderRequestById,
   getMyAccount,
   createNewBundle,
   deleteBundle,
   updateBundle,
   getBundleById,
   getDefaultAccessForStore,
   getDifferentAccessForStore,
   getBundleDefaultNotifications,
   initStoreDataForReorder,
}  from 'admin/api/AuthApi';
import { push } from 'connected-react-router';
import { updateCountStateAfterDelete } from 'admin/state/modules/resources/operations';
import Router from 'admin/routes/router';
import toast from "common/utils/toast";
import { history } from 'admin/state/store';
import DateFormatter from "common/utils/DateFormatter";
import { memberFetchDetailsOperation } from "../members/operations";
import { getDefaultNotificationSettings } from "common/utils/utils";
import { generateUriSegment } from "common/utils/mediaRouteHelper";


export const fetchDetailsById = (id, callback) => {
   return async (dispatch) => {
      dispatch(actions.fetchStoreById());
      try {
         const { data } = await getStoreById(id)
         if(data?.product_type === 'content_bundle_item') {
            dispatch(push(Router.route('STORE_EDIT_BUNDLE').getCompiledPath({ id: generateUriSegment(id) })))
            return
         }

         let validationNumbers = await getValidationNumbers();
         let newData = { ...data }

         if(newData.product_type !== 'attachment_item') {
            newData = {
               ...newData,
               is_unlocked: false,
            }
         }

         if(!newData?.questions?.length) {
            newData = {
               ...newData,
               questions: [
                  {
                     name: '',
                     response_type: 'long_answer',
                     maximum_characters: '100',
                     edit_mode: false,
                     is_required: false,
                     new: true,
                  },
               ],
            }
         }

         if(callback){
            callback(newData);
         }

         dispatch(actions.fetchStoreByIdCompleted(newData));
         dispatch(actions.getStoreValidationNubers(validationNumbers?.data))
         Router.route('STORE_DETAILS').setTitle(data.name)
      } catch (error) {
         dispatch(actions.fetchStoreByIdFailed());
      }

   }
};

export const initResourcesOperation = (isGetOwner = true, fetchValidationNumbers = true, callback) => {
   return async (dispatch) => {
      // dispatch(actions.fetchResources());
      try {
         if(fetchValidationNumbers){
            let validationNumbers = await getValidationNumbers();
            await dispatch(actions.getStoreValidationNubers(validationNumbers?.data))
         }
         let collections = await getStoreCollections();

         let data = {}
         const slugs = ['custom_videos', null]
         const collectionsData = collections?.data?.filter(i => slugs.includes(i.system_slug))
         if(isGetOwner) {
            const owners =  await getModels()
            data = { owners: owners.data.data, collections: collectionsData }
         } else {
            data = { collections: collectionsData }
         }
         await dispatch(actions.fetchResourcesCompleted(data));
         if(callback) callback()
      } catch (error) {
         console.log(error);

         dispatch(actions.fetchResourcesFailed());
      }

   }
};

export const updateStore = (data, id, filters = [], filtersObject = {}, errorCallBack) => {
   return async (dispatch) => {
      try {
         // let { data: updatedData } =
         await updateStoreData(id, data);
         // dispatch(actions.updateStoreList(updatedData));
         if(!!filters?.length) {
            // console.log(filters);
            // const params = generateUrlParams(filtersObject)
            // console.log(params);
            await dispatch(fetchDetails(filters, true))
         }
         history.block(() => { return true })
         toast.info('Your changes have been saved')
         dispatch(push(Router.route('STORE').getCompiledPath()))
      } catch (error) {
         dispatch(actions.updateStoreFailed(error.response));
         errorCallBack(error.response.data)
      }

   }
};

export const deleteStore = (id, name, isRedirect, param, product_type, callBack) => {
   return async (dispatch, getState) => {
      dispatch(actions.setDeleteModal({ loading: true }));
      try {
         if(!!product_type && product_type === 'content_bundle_item') {
            await deleteBundle(id)
         } else {
            await deleteProduct(id)
         }
         dispatch(actions.setDeleteModal({ loading: false, item: null, isOpen: false }));

         if(isRedirect) {
            dispatch(push({
               pathname: Router.route('STORE').getCompiledPath(),
               search: `?action=deleted&name=${ name }`,
            }))
            toast.remove(`${ name } has been deleted`)
         } else {
            let length = getState().store?.store?.data?.length
            if(length === 1) {
               dispatch(fetchDetails(param))
            }
            dispatch(updateCountStateAfterDelete(id, 'store'));
            dispatch(actions.deleteStoreCompleted(id))
            toast.remove(`${ name } has been deleted`)
         }
      } catch ({ response: { data } }) {
         dispatch(actions.setDeleteModal({ loading: false }));


         const warningModal = {
            isOpen: true,
            description: data.message,
            reason: data.reason,
            buttonText: 'Ok',
            title: 'Store item cannot be deleted',
            cancelText: 'Contact support',
            secondaryButtonClassName: 'intercom-content-cannot-be-deleted',
         }
         if(callBack) callBack(warningModal)
      }

   }
};

export const createNewStore = (data) => {
   return async (dispatch) => {
      dispatch(actions.createNewStore());
      try {
         await createStore(data);
         dispatch(actions.createNewStoreCompleted())
         history.block(() => { return true })
         if(data.active) {
            toast.success(`${ data.name } has been published`)
         }
         if(!data.active && !data.publish_date) {
            toast.success(`${ data.name } has been saved`)
         }
         if(!!data.publish_date) {
            toast.success(`${ data.name } has been scheduled`)
         }
         dispatch(push(Router.route('STORE').getCompiledPath()))
      } catch (error) {
         if(error.response) {
            const err = error.response.data;
            dispatch(actions.createNewStoreFailed(err));
            if(!!err){
               if(err.publish_date) {
                  if(err.publish_date[0] === 'The publish date cannot be in past') {
                     toast.error(err.publish_date[0]);
                  } else {
                     toast.error('Select publish date and time');
                  }
               } else {
                  toast.error('Please fix errors below');
               }
            }
         } else {
            toast.error('Something went wrong');
         }
      }
   }
};

export const fetchDetails = (filter, isUpdate = false, isInsideModal = false, isReorderMode) => {
   return async (dispatch) => {
      if(!isUpdate) {
         dispatch(actions.fetchDetails());
      }
      try {
         let resp

         if(isReorderMode) {
            const response = (await initStoreDataForReorder(filter?.filter(it => it?.includes('sortBy'))))?.data
            resp = {
               data: response,
            }
         } else {
            resp = (await initStoreData(filter, isInsideModal))?.data
         }

         dispatch(actions.fetchDetailsCompleted(resp, filter?.length > (isInsideModal ? 4 : 2)))
      } catch (error) {
         dispatch(actions.fetchDetailsFailed());
      }
   }
};

export const fetchNewDetails = (param, isReorderMode) => {
   return async (dispatch) => {
      dispatch(actions.fetchNewStore());
      try {
         let resp

         if(isReorderMode) {
            const response = (await initStoreDataForReorder(param?.filter(it => it?.includes('sortBy'))))?.data
            resp = {
               data: response,
            }
         } else {
            resp = (await getFilterStoreData(param))
         }
         dispatch(actions.fetchNewStoreCompleted(resp))
      } catch (error) {
         if(error && error?.code === "ERR_CANCELED") {
            return
         }
         dispatch(actions.fetchNewStoreFailed());
      }
   }
};

export const fetchFilterDetails = (param = [], isReorderMode) => {
   return async (dispatch) => {
      dispatch(actions.fetchFilterStore());
      try {
         let resp

         if(isReorderMode) {
            const response = (await initStoreDataForReorder(param?.filter(it => it?.includes('sortBy'))))?.data
            resp = {
               data: response,
            }
         } else {
            resp = (await getFilterStoreData(param))?.data
         }

         dispatch(actions.fetchFilterStoreCompleted(resp))
         dispatch(actions.afterFilterCompleted())
      } catch (error) {
         if(error && error?.code === "ERR_CANCELED") {
            return
         }

         dispatch(actions.fetchFilterStoreFailed());

      }
   }
};

// STORE CATEGORIES

export const initCollectionById = (id) => {
   return async (dispatch) => {
      dispatch(actions.fetchCollectionById());
      try {
         const response = await getCollectionBuId(id)
         dispatch(actions.fetchCollectionByIdCompleted(response))
      } catch (error) {
         if(error.response) {
            dispatch(actions.fetchCollectionByIdFailed(error.response));
         }
      }
   }
};
export const editeCategory = (id, data) => {
   return async (dispatch) => {
      dispatch(actions.updateCategoryData());
      try {
         await updateCategory(id, data)
         dispatch(actions.updateCategoryDataCompleted({ id, name: data.name }))
      } catch (error) {
         if(error.response){
            dispatch(actions.updateCategoryDataFailed(error.response));
         }
      }
   }
};
export const createNewCategory = (data) => {
   return async (dispatch) => {
      dispatch(actions.createNewCategory());
      try {
         const response = await createCategory(data)
         dispatch(actions.createNewCategoryCompleted(response))

      } catch (error) {
         if(error.response) {
            dispatch(actions.createNewCategoryFailed(error.response));
         }
      }
   }
};
export const deleteCutomCategory = (id) => {
   return async (dispatch) => {
      dispatch(actions.deleteCategory());
      try {
         await deleteCategory(id)
         dispatch(actions.deleteCategoryCompleted(id))
      } catch (error) {
         if(error.response) {
            dispatch(actions.deleteCategoryFailed(error.response));
         }
      }
   }
};

export const initCategoriesOperation = () => {
   return async (dispatch) => {
      try {
         const { data }  = await initCategories();
         const newData = data?.data?.map(el => {
            return {
               value: el.id,
               name: el.name,
            }
         })
         dispatch(actions.fetchAllCategories(newData))
      } catch (error) {

      }
   };
};

export const initOrdersRequestsOperation = (query = '') => {
   return async (dispatch) => {
      dispatch(actions.fetchOrderRequestsStart())
      try {
         if(query?.length > 2) {
            dispatch(getOrderRequestsByFilters(query, true))
            return
         }
         const { data }  = await getOrderRequests(query, true)
         let hasOrderRequestsForms = true
         // if(!data.data.length) {
         //    const { data } = await getOrderRequestForms(['paginate=true'])
         //    hasOrderRequestsForms = !!data.data.length
         // }
         dispatch(actions.fetchOrderRequestsCompleted({ data, hasOrderRequestsForms }))
      } catch (error) {
         console.log(error);
      }
   };
};

export const getOrderRequestsByFilters = (query = '') => {
   return async (dispatch) => {
      dispatch(actions.fetchOrderRequestsByFilterStart())
      try {
         const { data } = await getOrderRequests(query)
         dispatch(actions.fetchOrderRequestsByFilterCompleted(data))
      } catch (error) {
         if(error && error?.code === "ERR_CANCELED") {
            return
         }
         dispatch(actions.fetchOrderRequestsByFilterFail())
      }
   };
};

export const getNewOrderRequests = (query = '') => {
   return async (dispatch) => {
      dispatch(actions.fetchNewOrderRequestsStart())
      try {
         const { data } = await getOrderRequests(query)
         dispatch(actions.fetchNewOrderRequestsCompleted(data))
      } catch (error) {
         if(error && error?.code === "ERR_CANCELED") {
            return
         }
         dispatch(actions.fetchNewOrderRequestsFail())
      }
   };
};

// export const initOrderRequestForms = (query = '') => {
//    return async (dispatch) => {
//       try {
//          const { data } = await getOrderRequestForms(query)
//          dispatch(actions.fetchOrderRequestForms(data))
//       } catch (error) {
//       }
//    };
// };

// export const getNewOrderRequestForms = (query = '') => {
//    return async (dispatch) => {
//       dispatch(actions.fetchNewOrderRequestFormsStart())
//       try {
//          const { data } = await getOrderRequestForms(query)
//          dispatch(actions.fetchNewOrderRequestFormsCompleted(data))
//       } catch (error) {
//          if(error && error?.code === "ERR_CANCELED") {
//             return
//          }
//          dispatch(actions.fetchNewOrderRequestFormsFail())
//       }
//    };
// };

export const fetchOrderRequestById = (id, callBack) => {
   return async (dispatch) => {
      dispatch(actions.fetchActiveOrderRequestStart())
      try {
         const { data } = await getOrderRequestById(id)
         dispatch(actions.fetchActiveOrderRequestCompleted(data))
         dispatch(actions.updateOrderRequestsListData({ ...data, isChangeOnlySeenStatus: true }))
         dispatch(memberFetchDetailsOperation(data?.member?.id, null, data?.member))
         if(!!callBack) {
            callBack(data)
         }
      } catch (error) {
         dispatch(actions.fetchActiveOrderRequestFail())
      }
   };
};

//Content bundles

export const initDataForNewBundleOperation = (data = {}) => {
   return async (dispatch) => {
      dispatch(actions.initResourcesBundleStart())
      try {
         const defaultAccesses = await getDefaultAccessForStore()
         const differentAccesses = await getDifferentAccessForStore()
         const myAccountInfo = await getMyAccount()
         const collections = await getStoreCollections();
         const validationNumbers = await getValidationNumbers();
         const { data: { new_bundle: { mass_private_message, auto_tweet } } } = await getBundleDefaultNotifications()

         const defaultNotifications = { published: { mass_private_message, auto_tweet } }
         const publishDefaultSettings = getDefaultNotificationSettings(defaultNotifications?.published || {});

         let newData = {
            active: true,
            is_future_publish_enabled: false,
            duration: 24,
            photosets: [],
            videos: [],
            vaults: [],
            recorded_streams: [],
            access_for_members_mode: "all",
            access_for_others_mode: "all",
            product_type: 'content_bundle_item',
            category: 'content_bundle_item',
            name: '',
            description: '',
            thumbnail: {},
            category_id: '',
            access_members_all: defaultAccesses?.data?.access_members_all,
            access_others_all: defaultAccesses?.data?.access_others_all,
            access_members_different: differentAccesses?.data?.multiple_access_members,
            member_statistics: differentAccesses?.data?.member_statistics,
            access_others_different: differentAccesses?.data?.multiple_access_others,
            highestMembershipId: differentAccesses?.data.highest_id,
            userInfo: {
               name: myAccountInfo.data.screen_name,
               avatar: myAccountInfo.data.compressed_avatar_src,
               email: myAccountInfo.data.email,
            },
            owner_uuid: myAccountInfo.data.uuid,
            on_home_page: true,
            default_notification_settings: defaultNotifications,
            send_tweet_on_publish: publishDefaultSettings.tweet,
            notify_members_on_publish: publishDefaultSettings.notify_members,
            thumbnail_is_sfw: false,
            ...data,
         }
         await dispatch(actions.getStoreValidationNubers(validationNumbers?.data))
         await dispatch(actions.fetchResourcesCompleted({ collections: collections.data }));
         await dispatch(actions.initResourcesBundleCompleted({ newData, type: 'create' }))
      } catch (error) {

      }
   }
}

export const createNewBundleOperation = (data, callBack) => {
   return async (dispatch) => {
      try {

         await createNewBundle(data)

         history.block(() => { return true })
         dispatch(actions.clearNewBundleData())
         dispatch(push(Router.route('STORE').getCompiledPath()))

         if(data.active) {
            toast.success(`${ data.title } has been published`)
         }
         if(!data.active && !data.publish_date) {
            toast.success(`${ data.title } has been saved`)
         }
         if(!!data.publish_date) {
            toast.success(`${ data.title } has been scheduled`)
         }
      } catch (error) {
         dispatch(actions.changeNewBundleErrors(error.response.data))
         if(callBack) {
            callBack(error.response.data)
         }
         // if(!!error.response.data?.publish_date) {
         //    toast.error(`${ error.response.data?.publish_date?.[0] }`)
         // }
      }
   }
}

export const getStoreBundleById = (id) => {
   return async (dispatch) => {
      await dispatch(actions.initResourcesBundleStart())
      try {
         const { data } = await getBundleById(id)
         if(data?.product_type !== 'content_bundle_item') {
            dispatch(push(Router.route('STORE_DETAILS').getCompiledPath({ id: generateUriSegment(id) })))
         }
         await Router.route('STORE_EDIT_BUNDLE').setTitle(data.name)
         let newData = {
            ...data,
            description: data?.description,
            thumbnail: { path: JSON.parse(data?.image_full_src)?.[0], path_prefix: JSON.parse(data?.image_paths)?.[0] },
            duration: data?.content_bundle_duration_in_hours === 0 ? 'infinite' : data?.content_bundle_duration_in_hours,
            // duration_enabled: data?.content_bundle_duration_in_hours !== 0,
            userInfo: {
               name: data.owner_screen_name,
               avatar: data.owner_avatar,
               id: data.owner_uuid,
            },
            access_members_all: data?.access_members_all,
            access_members_different: data?.multiple_access_members,
            access_others_all: data?.access_others_all,
            access_others_different: data?.multiple_access_others,
            available_for_members: !!data?.available_for_members ? data?.available_for_members : null,
         }

         let content = {
            photosets: [],
            videos: [],
            vaults: [],
            recorded_streams: [],
         }

         data?.content_bundle?.forEach(item => {
            if(item?.contentable_type === 'video') {
               content = {
                  ...content,
                  videos: [
                     ...content?.videos,
                     {
                        ...item.contentable,
                        type: 'videos',
                        order: item?.order,
                     },
                  ],
               }
            }
            else if(item?.contentable_type === 'vault') {
               content = {
                  ...content,
                  vaults: [
                     ...content?.vaults,
                     {
                        ...item.contentable,
                        type: 'vaults',
                        order: item?.order,
                        image_full_src: item?.contentable?.vault_bundle_item_poster_full_src,
                        image_thumb_src: item?.contentable?.vault_bundle_item_poster_full_src,
                     },
                  ],
               }
            } else if(item?.contentable_type === 'photoset'){
               content = {
                  ...content,
                  photosets: [
                     ...content?.photosets,
                     {
                        ...item.contentable,
                        cover_photo: item?.contentable?.cover_image?.cf_path,
                        photos_count: item?.contentable?.photos_count,
                        type: 'photosets',
                        order: item?.order,
                     },
                  ],
               }
            } else if(item?.contentable_type === 'recorded_stream'){
               content = {
                  ...content,
                  recorded_streams: [
                     ...content?.recorded_streams,
                     {
                        ...item?.contentable,
                        type: 'recorded_streams',
                        order: item?.order,
                     },
                  ],
               }
            }
         })

         content = {
            photosets: content?.photosets.sort((a, b) => a.order - b.order),
            videos: content?.videos.sort((a, b) => a.order - b.order),
            vaults: content?.vaults.sort((a, b) => a.order - b.order),
            recorded_streams: content?.recorded_streams.sort((a, b) => a.order - b.order),
         }

         newData = {
            ...newData,
            ...content,
         }

         if(newData.publish_date !== null) {
            newData = {
               ...newData,
               publish_date: DateFormatter.convertToUserTz(newData.publish_date),
            }
         }

         const collections = await getStoreCollections();
         const validationNumbers = await getValidationNumbers();
         await dispatch(actions.getStoreValidationNubers(validationNumbers?.data))
         await dispatch(actions.initResourcesBundleCompleted({ newData, type: 'edit' }))
         await dispatch(actions.fetchResourcesCompleted({ collections: collections.data }));
      } catch (error) {
         console.log(error);
      }
   }
}

export const editBundleOperation = (id, data, filters, callback) => {
   return async (dispatch) => {
      try {
         // const { data: updatedData } =
         await updateBundle(id, data)

         history.block(() => { return true })

         if(!!filters?.length) {
            // console.log(filters);
            await dispatch(fetchDetails(filters, true))
         }

         // dispatch(actions.updateStoreList(updatedData));
         toast.success(`Your changes have been saved`)
         dispatch(actions.clearActiveBundleData())
         dispatch(push(Router.route('STORE').getCompiledPath()))
      } catch (error) {
         let errors = error.response.data
         if(typeof errors === 'string') {
            toast.info(errors,
               {
                  className: 'custom-ams-toast !bg-error custom-ams-toast-container',
               }
            )
            errors = {
               access: errors,
            }
         } else if('photosets' in errors && 'videos' in errors && 'vaults' in errors && 'recorded_streams' in errors) {
            errors = {
               ...errors,
               content: 'Required',
               photosets: null,
               videos: null,
               vaults: null,
               recorded_streams: null,
            }
         }
         dispatch(actions.setActiveBundleErrors(errors))
         if(callback) {
            callback(errors)
         }
      }
   }
}


export const  deleteBundleOperation = (id, name) => {
   return async (dispatch) => {
      try {
         await deleteBundle(id)
         dispatch(actions.deleteStoreBundleItem())
         dispatch(actions.clearActiveBundleData())
         history.block(() => { return true })
         dispatch(push(Router.route('STORE').getCompiledPath()))
         toast.success(`${ name } has been deleted`)
      } catch (error) {
      }
   }
}


// const generateUrlParams = (filters) => {

//    if(Object.keys(filters)?.length) {
//       // const currentFiltersJson = encodeURIComponent(JSON.stringify(filters))
//       return encodeURIComponent(JSON.stringify(filters))
//    }
//    return ''
// }
